module.exports = __webpack_public_path__ + "static/media/invoice-list-icon.911bdeff.svg";